/**
 * @deprecated Use ICoreDataEntity instead
 */
export class CoreDataEntity {
  constructor(public readonly objectType: string | number, public readonly id: string) {}
}

export class CoreDataEntityHelper {
  public static equals(dataEntity1: CoreDataEntity, dataEntity2: CoreDataEntity): boolean {
    if (dataEntity1 && dataEntity1) {
      return dataEntity1.id === dataEntity2.id && dataEntity1.objectType === dataEntity2.objectType;
    } else {
      return !dataEntity1 && !dataEntity2;
    }
  }
}

export interface ICoreDataEntity {
  Id: string;
  ObjectType: string | number;
}
